import React, { FC } from 'react'

import { Text } from '../text'
import { Flex } from '../box'

type Props = {
  ['data-test-id']?: string
  message?: React.ReactNode
  ml?: number | number[]
}

export const Error = ({ message, 'data-test-id': dataTestId }: Props) => {
  if (!message || (typeof message === 'string' && !message.trim())) return null

  return (
    <Flex mt={2}>
      <Text data-test-id={dataTestId} fontSize={12} color='red-dark-100'>
        {message}
      </Text>
    </Flex>
  )
}
